import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c75810b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "bottom-left"
};
const _hoisted_8 = {
  class: "item"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = {
  class: "bottom-right"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = {
  class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, " 地块面积：" + _toDisplayString($data.plotInfo.plotArea) + "亩 ", 1), _createElementVNode("div", _hoisted_4, "种植品种：" + _toDisplayString($data.plotInfo.actionPlanVo.plant), 1), _createElementVNode("div", _hoisted_5, "负责人：" + _toDisplayString($data.plotInfo.managerName), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, "设备总数：" + _toDisplayString($data.plotInfo.equipmentCount), 1), _createElementVNode("div", _hoisted_9, "今日报警：" + _toDisplayString($data.plotInfo.equipmentWarningVo.dayCount), 1), _createElementVNode("div", _hoisted_10, "累计报警：" + _toDisplayString($data.plotInfo.equipmentWarningVo.allCount), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, "在线：" + _toDisplayString($data.plotInfo.equipmentOnlineCount), 1), _createElementVNode("div", _hoisted_13, "离线：" + _toDisplayString($data.plotInfo.equipmentOfflineCount), 1)])])]);
}